<match-wrapper
    label="{{ label }}"
    fieldName="{{ fieldName }}"
    [showRemoveIcon]="showRemoveIcon"
    (onRemoveMatch)="removeMatch()"
>
    <div
        class="string-match"
        provideParentForm
    >
        <string-match-config
            [disallowRegex]="disallowRegex"
            [editable]="editable"
            id="string-match"
        ></string-match-config>
    </div>
</match-wrapper>
